import styled from 'styled-components';
import { Menu, Button } from 'antd';
import { PushpinOutlined } from '@ant-design/icons';

export const TableWrapper = styled.div`
  min-height: 500px;
  height: 100%;
  position: relative;

  .BaseTable__row-cell {
    .action-bar {
      display: none;
    }

    &:hover {
      .action-bar {
        display: block;
      }
    }
  }
`;

export const ViewerSessionsTableHeader = styled.div`
  height: 50px;
  line-height: 50px;
  position: relative;

  &:first-child .BaseTable__header-cell-text {
    padding-left: 7.5px;
  }

  .BaseTable__header-cell {
    padding-right: 16px;
    padding-left: 8px !important;
  }

  .BaseTable__header-cell-text {
    white-space: nowrap;
  }

  .BaseTable__sort-indicator {
    margin-right: 3px;
  }

  & i {
    position: absolute;
    right: 4px;
    top: 20px;
  }

  &:hover i {
    display: inline-block;
  }
`;

export const Styled_ViewerTableTitle = styled.div`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const Styled_IconWrapper = styled.span`
  padding: 10px;

  .anticon {
    vertical-align: 0;
  }
`;

export const FooterWrapper = styled.div`
  text-align: center;
  font-size: 1em;
  font-weight: 600;
`;

export const KebabIcon = styled.span`
  height: fit-content;
  font-size: initial;
`;

export const AnchorIcon = styled(PushpinOutlined)`
  position: absolute;
  right: 4px;
  top: 10px;
  color: #000;
`;

export const ItemContent = styled.span`
  margin-right: 14px;
`;

export const MetricMenu = styled(Menu)`
  overflow: scroll;
  max-height: 300px;

  .li {
    margin-top: 0;
    margin-bottom: 0 !important;
  }

  .ant-menu-item-selected {
    background-color: unset !important;
    color: unset;
  }
`;

export const StyledButton = styled(Button)`
  margin-bottom: 10px;
`;

export const DataTriggerBoxWrapper = styled.div`
  padding: 10px 0;
`;

export const DataTableWrapper = styled.div`
  height: calc(100% - 55px);
`;

export const DataTriggerBox = styled.div`
  white-space: nowrap;
  text-align: right;
  ${({ pushRight }) =>
    pushRight &&
    `
    position: relative;
    left: 10px;
  `}
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;
